const { h, render, Component } = require('preact');

class Gift extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.orderDetails.isGift && this.props.orderDetails.giftInfo){
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.gifted_to")}:</td>
          <td style="text-transform: capitalize">{this.props.orderDetails.giftInfo.giftRecipientName}</td>
        </tr>
      );
    }
    return null;
  }
}
module.exports = Gift
